module.exports = __webpack_public_path__ + "img/phone.a83b1dee.png";